module.exports = __webpack_public_path__ + "img/our_aim.46549eaf.svg";